import { AxiosError } from "axios";
import api, { API_VERSIONS } from "@/config/api";
import { recoverTokenInfo } from "@/utils/recoverTokenInfo";
import { CreateSummaryData } from "@/hooks/mutations/usePostCreateSummary";

const postCreateSummary = async (data: CreateSummaryData): Promise<boolean | AxiosError> => {
  try {
    const initialToken = recoverTokenInfo();
    const res = await api.post<boolean | AxiosError>(`/${API_VERSIONS.v0}/recording/CreateSummary`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${initialToken}`,
      },
    });
    return res.data;
  } catch (error) {
    console.error("Error creating summary:", error);
    throw error;
  }
};

export default postCreateSummary;
